import { render, staticRenderFns } from "./UsualPowerSettingsPage.vue?vue&type=template&id=da3e74b4&scoped=true&"
import script from "./UsualPowerSettingsPage.vue?vue&type=script&lang=ts&"
export * from "./UsualPowerSettingsPage.vue?vue&type=script&lang=ts&"
import style0 from "./UsualPowerSettingsPage.vue?vue&type=style&index=0&id=da3e74b4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3e74b4",
  null
  
)

export default component.exports